module.exports = __webpack_public_path__ + "img/ch3.00242c4b.jpeg";